const coerceFlag = raw => {
  if (typeof raw === 'boolean') return raw;
  if (raw === 'true' || raw === 1 || raw === '1') return true;
  if (raw === 'false' || raw === 0 || raw === '0') return false;
  return undefined;
};

/** BE stores presets_enabled on linked_company (fallback: top-level on older payloads). */
const readRaw = record => {
  if (!record) return undefined;
  if (record.linked_company && record.linked_company.presets_enabled != null) {
    return record.linked_company.presets_enabled;
  }
  if (Object.prototype.hasOwnProperty.call(record, 'presets_enabled') && record.presets_enabled != null) {
    return record.presets_enabled;
  }
  return undefined;
};

/** Default: On for pilot, Off for existing-customer (M2 item 32 / C11). */
export const defaultTurnaroundExperience = record => {
  const isExisting =
    record?.record_type === 'existing_customer' || record?.is_pilot === false;
  return !isExisting;
};

/** Resolved On/Off for a scope record (console switch / telemetry). Does not gate form preset UI. */
export const isTurnaroundExperienceOn = record => {
  const coerced = coerceFlag(readRaw(record));
  if (coerced !== undefined) return coerced;
  return defaultTurnaroundExperience(record);
};

/** Optimistic local update of linked_company.presets_enabled. */
export const withPresetsEnabled = (record, enabled) => {
  if (!record) return record;
  return {
    ...record,
    linked_company: {
      ...(record.linked_company || {}),
      presets_enabled: !!enabled
    }
  };
};

/** PATCH body — single field, same pattern as send_email. */
export const turnaroundExperiencePatchBody = enabled => ({
  presets_enabled: !!enabled
});

export const turnaroundExperienceHistoryLabel = enabled =>
  enabled ? 'Turnaround experience turned on' : 'Turnaround experience turned off';
